export const TaskCategory = {
    MOVE_TASK: 'MOVE_TASK',
    REPLENISH_TASK: 'REPLENISH_TASK',
    FETCH_ITEM_TASK: 'FETCH_ITEM',
    LOD_CHECKLIST: 'LOD_CHECKLIST',
};
